<script lang="ts">
	import { createDroppable, type CreateDroppableInput } from "@dnd-kit/svelte";
	import { type Question } from "#gen/forms/v1/poll_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import QuestionEditor from "#lib/components/page/components/poll/QuestionEditor.svelte";
	import Button from "#lib/ui/Button/index.js";

	interface Props extends CreateDroppableInput {
		questions: Question[];
		activeQuestion?: string;
		onAdd?: () => void;
		onDuplicate?: (question: Question, index: number) => void;
		onRemove?: (question: Question, index: number) => void;
		onInput?: (question: Question, index: number) => void;
		onChange?: (question: Question, index: number) => void;
		onSelect?: (question: Question, index: number) => void;
		onMoveUp?: (question: Question, index: number) => void;
		onMoveDown?: (question: Question, index: number) => void;
	}

	let { questions = $bindable(), activeQuestion, onAdd, onDuplicate, onRemove, onInput, onChange, onSelect, onMoveUp, onMoveDown, ...rest }: Props = $props();
	const { attach } = $derived(createDroppable(rest));
</script>

<form class="question-dnd-container flex flex-col gap-4" {@attach attach} onsubmit={e => e.preventDefault()}>
	{#each questions as question, index (`${question.id}:${index}`)}
		<QuestionEditor
			id={`question-${question.id}`}
			{question}
			{index}
			total={questions.length}
			active={activeQuestion == question.id}
			onClick={() => onSelect?.(question, index)}
			onRemove={() => onRemove?.(question, index)}
			onDuplicate={() => onDuplicate?.(question, index)}
			onInput={question => onInput?.(question, index)}
			onChange={question => onChange?.(question, index)}
			{onMoveUp}
			{onMoveDown}
		/>
	{/each}
	<div>
		<Button data-action-name="add-poll" color="alternative" on:click={() => onAdd?.()}>
			Add poll
			<Icon name="plus" class="ml-2 h-4 w-4" />
		</Button>
	</div>
</form>

<style>
	.question-dnd-container :global([data-dnd-placeholder]) {
		visibility: visible !important;
		background-color: var(--color-primary-100);
		border-radius: 0.5rem;
	}

	.question-dnd-container :global([data-dnd-placeholder] *) {
		visibility: hidden !important;
	}
</style>
